<template>
  <div>
    <v-card class="ml-5 mb-3 mr-5">
      <v-card-title class="font-weight-bold ">
        <v-icon left color="success">mdi-comment</v-icon>
        <span> {{ comm.subject }}</span>
      </v-card-title>
      <v-card-text class="pt-1">
        <v-layout row wrap>
          <v-flex xs12 md7>
            <v-list>
              <div class="v-flex ml-3 mt-1">
                <v-icon color="blue-grey" class="mr-4">mdi-text</v-icon>
                <span class="font-weight-bold mr-2">Description :</span>

                <div
                  class="grey--text text--darken-3 body-1"
                  style="line-height: 1.7; white-space: pre-wrap; flex: 1;"
                >
                  {{ comm.description || "No description provided." }}
                </div>
              </div>
              <v-divider></v-divider>
              <v-list-tile class="px-0" v-show="comm.saleID">
                <v-icon color="blue-grey" class="mr-4">mdi-sale</v-icon>

                <div>
                  <a @click="showSaleDialog(comm.saleID)" class="button"
                    ><span class="font-weight-bold mr-2">Sale:</span>#
                    {{ comm.saleID }}
                    <small>Click to view sale details</small>
                  </a>
                </div>
              </v-list-tile>
              <v-layout row wrap class="mt-0">
                <v-flex xs12 class="ml-4">
                  <h3 class="mb-2">
                    Files {{ files.length > 0 ? `(${files.length})` : "" }}
                  </h3>
                  <!-- <upload-files /> -->
                  <div v-if="files.length === 0" class="grey--text">
                    No files attached.
                  </div>
                  <div v-else class="mt-6">
                    <v-layout row wrap>
                      <v-card
                        v-for="file in [...files].sort(
                          (a, b) => a.documentID - b.documentID
                        )"
                        :key="file.AttachmentID"
                        class="pa-3 mb-4 mx-2"
                        style="width: 24%; min-width: 280px;"
                        elevation="2"
                      >
                        <div class="mb-2">
                          <div
                            class="d-flex align-center justify-space-between"
                          >
                            <div
                              class="text-subtitle-1 font-weight-medium text-truncate"
                              style="max-width: 70%;"
                            >
                              File name: {{ file.fileName }}
                            </div>
                          </div>
                          <div
                            class="d-flex align-center justify-space-between mt-2"
                          >
                            <div
                              class="text-subtitle-1 font-weight-medium text-truncate"
                              style="max-width: 70%;"
                            >
                              Description: {{ file.fileDescription }}
                            </div>
                          </div>
                        </div>
                        <v-layout>
                          <!--  -->
                          <v-spacer></v-spacer>
                          <v-btn
                            small
                            color="success"
                            class="mr-1"
                            style="height: 28px;"
                            @click="view(doc)"
                          >
                            <v-icon class="mr-2">mdi-open-in-new</v-icon>
                            View</v-btn
                          >
                          <v-btn
                            small
                            color="success"
                            style="height: 28px;"
                            @click="openDeleteFileDialog(doc)"
                            >Delete</v-btn
                          >
                        </v-layout>
                        <div
                          style="height: 400px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 4px;"
                        >
                          <pdf
                            v-if="isPdf(doc.fileURL)"
                            :src="doc.fileURL"
                            style="width: 100%;"
                          ></pdf>
                          <img
                            v-else
                            :src="doc.fileURL"
                            style="width: 100%; height: auto; display: block;"
                          />
                        </div>
                      </v-card>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </v-list>
          </v-flex>
        </v-layout>
        <v-card-actions class="pa-4">
          <v-spacer />
        </v-card-actions>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="saleDialog"
      max-width="70%"
      style="background-color: brown;"
    >
      <v-btn
        icon
        dark
        small
        absolute
        right
        color="white"
        style="top: 100px; right: 100px; background-color: rgba(0,0,0,0.3);"
        @click="saleDialog = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <dedication-sale-view
        :style="{ padding: '0 !important' }"
        :key="dialogKey"
        :initial-data="{ dedicationSale }"
      />
    </v-dialog>
  </div>
</template>
<script>
import DedicationSaleView from "./DedicationSaleView.vue";
import uploadFiles from "./uploadFiles.vue";
export default {
  components: {
    DedicationSaleView,
    uploadFiles,
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  async created() {
    this.comm = this.initialData.comm;
  },
  data() {
    return {
      comm: "",
      files: [],
      saleDialog: false,
      dialogKey: 0,
      dedicationSale: "",
    };
  },
  methods: {
    async showSaleDialog(saleID) {
     // console.log(this.initialData)
      const sale = await this.initialData.sales.find(
        (s) => s.saleID === saleID
      );
      this.dedicationSale = { ...sale };
      this.saleDialog = true;
      this.dialogKey += 1;
    },
  },
};
</script>
